import StyledInput from 'components/styledInput/StyledInput';
import useInlineField from './useInlineField';

// The form's limit (TaskFormPanel).
const MAX_LENGTH = 120;
const focusOnMount = (element) => element?.focus();

/**
 * The title of a task in its panel's header: a click turns it into the form's
 * field, Enter or leaving it saves, Escape gives it back. An emptied title is
 * not sent: the task keeps its own. `canEdit` false: read only.
 */
const TaskTitleField = ({ title, canEdit, onSave }) => {
  const field = useInlineField({ value: title, onSave: (next) => onSave({ title: next }) });
  if (!canEdit) return title;
  const finish = () => {
    const next = field.draft.trim();
    if (next) field.commit(next);
    else field.cancel();
  };
  if (field.editing) {
    return (
      <StyledInput
        type="text"
        value={field.draft}
        maxLength={MAX_LENGTH}
        inputRef={focusOnMount}
        onChange={(event) => field.setDraft(event.target.value)}
        onBlur={finish}
        onKeyDown={(event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          finish();
        }}
      />
    );
  }
  return (
    <button
      type="button"
      onClick={field.start}
      className="-mx-1 max-w-full rounded-md px-1 text-left transition-colors hover:bg-gray-100"
    >
      {field.shown}
    </button>
  );
};

export default TaskTitleField;
